// Key-value store for list filters/search/pagination + scroll positions.
// Backed by sessionStorage so state survives a page refresh within the tab,
// and kept in an in-memory mirror for fast synchronous reads. State is
// remembered app-wide (across section navigation) and only clears when the
// browser tab is closed.
const SS_KEY = "vt_list_state";
const store = {};

(function hydrate() {
  try {
    const raw = sessionStorage.getItem(SS_KEY);
    if (raw) Object.assign(store, JSON.parse(raw));
  } catch {
    /* ignore corrupt/unavailable storage */
  }
})();

function persist() {
  try {
    sessionStorage.setItem(SS_KEY, JSON.stringify(store));
  } catch {
    /* ignore quota/unavailable storage */
  }
}

export function getListState(key, fallback) {
  return key in store ? store[key] : fallback;
}

export function setListState(key, value) {
  store[key] = value;
  persist();
}
